import Model from "./Model";
import TravelInfo from "./TravelInfo";

export default class Travel extends Model {
    constructor(data) {
        super(data);

        this.relation('travelInfo', TravelInfo);
    }

    get description_limited() {
        return _.truncate(
            this.get('description'), {
            'length': 300,
        });
    }
}
